import PropTypes from "prop-types";
import { Divider, Paper } from "@mantine/core";
import BulkUploadsStats from "./components/BulkUploadsStats";
import BulkUploadsContent from "./BulkUploadsContent";

export default function BulkUploadsPage({ isSuperAdmin = false }) {
  return (
    <div className="flex flex-col gap-6 p-4 md:p-6">
      <BulkUploadsStats isSuperAdmin={isSuperAdmin} />
      <Divider />
      <Paper shadow="xs" p={{ base: "sm", sm: "xl" }}>
        <BulkUploadsContent isSuperAdmin={isSuperAdmin} />
      </Paper>
    </div>
  );
}

BulkUploadsPage.propTypes = {
  isSuperAdmin: PropTypes.bool,
};
